import styled from 'styled-components';

import {
  flexbox,
  justifyContent,
  alignItems,
  inlineFlexbox,
  flexDirection
} from '../../styles/helpers/flexbox';

export const StudentListWrapper = styled.div((props) => {
  const { typography } = props.theme;

  return `
    min-width: 260px;
    max-width: 260px;
    font-family: ${typography.family};
    font-size: 14px;
    left: 0;
    background-color: white;
    z-index: 7;
    overflow: hidden;
    position: -webkit-sticky;
    position: sticky;
`;
});

export const CurrentAssigned = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 5px;
  width: 100px;
  font-size: 12px;
  font-weight: 400;
  text-align: right;
`;

export const ListItemContainer = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('space-between')};
    ${alignItems('center')};

    box-sizing: border-box;
    border: 1px solid ${colours.grey[400]};
    border-left: none;
    border-top: none;
    height: 33px;
    background-color: white;
    &:last-of-type {
      margin-bottom: 60px;
    }
  `;
});

export const ListItem = styled.div((props) => {
  const { palette, colours } = props.theme;

  /* eslint-disable */
  return `
    ${flexbox()};
    ${justifyContent('space-between')};
    padding: 5px;
    font-weight: 400;
    color: ${palette.primary.dark};
    width: ${props.showCheckbox === true ? `80%` : `100%`};
    border-right: ${
      props.showCheckbox === true ? `2px solid ${colours.grey[400]}` : 'none'
    };
    height: 22px;
    align-items: center;
    cursor: pointer;
    user-select: none;

    #assignedActivity {
        color: ${palette.primary.dark};
    }

    &:hover {
      background-color: ${colours.grey[100]};
    }
`;
  /* eslint-enable */
});

export const HeaderContainer = styled(ListItemContainer)((props) => {
  const { colours } = props.theme;

  return `
  height: 48px;
  border: 1px solid ${colours.grey[400]};
  border-left: none;
  background-color: white;
  position: sticky;
  top: 0;
  max-width: 262px;
  width: 260px;

  @media screen and (max-width: 1100px) {
    height: 38px;
  }
  `;
});

export const StudentHeader = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${justifyContent('space-between')};
    font-weight: 600;
    padding: 0px 5px;
    border-right: 2px solid ${colours.grey[400]};
    user-select: none;
    height: 47px;
    width: 80%;

    .title {
        ${inlineFlexbox()};
        ${justifyContent('flex-start')};
        font-size: 12px;
        font-weight: 400;
        width: 120px;
        padding-left: 5px;
        max-height: 10px;
        cursor: pointer;

        .label {
          padding-left: 5px;
        }
    }

    div:nth-child(1) {
      height: 10px;
    }

    div[class*='svgIconComponent---']: {
        width: 20px !important;
    }
`;
});

export const SvgWrapper = styled.div(
  (props) => `
    path {
      fill: ${props.status ? '#1981c4' : 'black'} !important;
    }
  `
);

export const LoaderWrapper = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('center')};
  flex: 1;
  height: 100%;
`;

export const StudentListItemWrapper = styled.div`
  margin-top: 0.01px;
`;

export const CheckboxWrapper = styled.span((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    width: 40px;
    height: 100%;
    background-color: ${colours.grey[200]};

    > div {
      margin: 0;
    }
`;
});

export const ContextMenuAction = styled.div((props) => {
  const { colours, palette } = props.theme;
  /* eslint-disable indent */
  return `
  ${flexbox()};
  ${alignItems('center')};

  width: 100%;
  height: 30px;
  padding-left: 10px;
  color: ${palette.primary.dark};
  border-bottom:  ${!props.last ? `1px solid ${colours.grey[400]};` : 'none'};
  border-top: ${props.first ? `1px solid ${colours.grey[400]};` : 'none'};
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${colours.grey[100]};
  }

  span[class*="isvg"] {
    margin-right: 10px;
  }
`;
  /* eslint-enable indent */
});

export const StudentDetails = styled.div((props) => {
  const { palette, typography } = props.theme;
  /* eslint-disable indent */
  return `
  ${flexbox()};
  ${flexDirection('column')};

  width: 100%;
  padding: 10px;
  color: ${palette.primary.dark};
  font-size: ${typography.info.size};
  font-weight: ${typography.info.weight};
`;
});

export const StudentDetailsRow = styled.div`
  font-size: 12px;
  height: 20px;
`;

export const StudentName = styled(StudentDetailsRow)((props) => {
  const { typography } = props.theme;

  return `
    font-size: ${typography.info.size};
    font-weight: ${typography.info.weight};
  `;
});

export const StudentGroup = styled(StudentName)``;



// WEBPACK FOOTER //
// ./components/student-list/styled.js